import React from "react";

import { siteLocationPrefix } from "../../constants";
import { TestInput } from "./TestInput";
import * as styles from "./TestStyle.module.css";

export const TestAMSActions = () => (
  <div className={styles.pcAmsActionsWrapper}>
    <h3>Partner Center AMS Actions</h3>
    <TestInput
      actionURL={`${siteLocationPrefix}/test/setOGCUserOverrideForRoleAdding`}
      label="Set OCG Email to override on role adding process ('delete' to remove)"
      buttonText="set"
      actionName="ogcEmailOverride"
    />
    <TestInput
      actionURL={`${siteLocationPrefix}/test/ams/getPartnerCenterProgramsBySellerId`}
      label="Get Partner Center Programs by Seller ID"
      buttonText="get"
      actionName="sellerId"
    />
    <TestInput
      actionURL={`${siteLocationPrefix}/test/ams/getAllPartnerCenterSellersByEmail`}
      label="Get Partner Center Sellers by Seller Email"
      buttonText="get"
      actionName="email"
    />
    <TestInput
      actionURL={`${siteLocationPrefix}/test/ams/getPartnerCenterSellerDetailsBySellerId`}
      label="Get Partner Center Seller Details by Seller ID"
      buttonText="get"
      actionName="sellerId"
    />
    <TestInput
      actionURL={`${siteLocationPrefix}/test/ams/getPartnerCenterRolesBySelledId`}
      label="Get Partner Center Roles by Seller ID"
      buttonText="get"
      actionName="sellerId"
    />
    <TestInput
      actionURL={`${siteLocationPrefix}/test/ams/getAllPartnerCenterAccountsByOwnerEmail`}
      label="Get Partner Center Accounts by Owner Email"
      buttonText="get"
      actionName="email"
    />
    <TestInput
      actionURL={`${siteLocationPrefix}/test/ams/getAllPartnerCenterAccountsByStudioName`}
      label="Get Partner Center Accounts by Studio Name"
      buttonText="get"
      actionName="studioName"
    />
    <TestInput
      actionURL={`${siteLocationPrefix}/test/ams/getPartnerCenterAvailabilityByStudioName`}
      label="Get Partner Center Name Availability by Studio Name"
      buttonText="get"
      actionName="studioName"
    />
    <br />
    <br />
  </div>
);
